import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { useTranslation } from '@/components/utils/translations';
import {
  formatInstitutionalMomentum,
  resolveInstitutionalMomentum,
} from '@/lib/institutionalMomentum';

export default function MomentumSummary({ momentumScores, momentum_12w }) {
  const { t } = useTranslation();
  const value = resolveInstitutionalMomentum(momentumScores, momentum_12w);
  const hasValue = value != null && !Number.isNaN(Number(value));
  const n = Number(value);

  return (
    <Card className="border-0 shadow-md">
      <CardContent className="p-3 md:p-4 flex flex-col justify-center items-center h-full">
        <p className="text-xs md:text-sm text-[#5C6B7A] text-center">{t('momentum')}</p>
        {hasValue ? (
          <div className="flex items-center justify-center gap-1 my-1">
            <p className={`text-lg md:text-2xl font-bold flex items-center justify-center gap-1 ${n >= 0 ? 'text-green-600' : 'text-red-600'}`}>
              {n >= 0 ? <TrendingUp className="w-4 h-4 md:w-6 md:h-6" /> : <TrendingDown className="w-4 h-4 md:w-6 md:h-6" />}
              {formatInstitutionalMomentum(n)}
            </p>
          </div>
        ) : (
          <p className="text-lg md:text-2xl font-bold text-[#5C6B7A] my-1">—</p>
        )}
        <div className="h-[16px] md:h-[20px]" />
      </CardContent>
    </Card>
  );
}
